import { Messages } from '~src/codegen/Localize';
import { IPasswordPolicy } from './IPasswordPolicy';

export class MaximumPasswordLengthPolicy implements IPasswordPolicy {

    private maxLength: number;

    public constructor(maxLength: number) {
        this.maxLength = maxLength;
    }

    public isValid(password: string): boolean {
        return password && password.length <= this.maxLength;
    }

    public getErrorMessage(): string {
        return Messages.passwordPolicies_maximumLength({MAX_LENGTH: this.maxLength.toString()});
    }

    public getTestId(): string {
        return MaximumPasswordLengthPolicy.name;
    }
}
